
import { z } from "zod";

export const EscalationRiskTierValues = ["CRITICAL", "AT_RISK", "WATCH", "HEALTHY"] as const;
export const EscalationRiskTierSchema = z.enum(EscalationRiskTierValues);
export const EscalationRiskTier = EscalationRiskTierSchema.enum;
export type EscalationRiskTier = (typeof EscalationRiskTierValues)[number];
